import React, { useEffect, useState } from "react";

import axios from "axios";
import { Link } from "react-router-dom";
import cup from "../../../../../../../../assets/images/cup 2.png";
import EnterImage from "../../../../../../../../assets/images/unsplash_hUHzaiAHuUc.png";
import AllDataHeader from "../../../../../../../Reuseable/AllDataHeader";
import AuditionCardReuse from "../../../../../../../AuditionAdmin/AuditionCardReuse";

const RoundInstructionVideoList = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    axios
      .get("/api/audition-admin/audition/round-instruction-video/list")
      .then((res) => {
        if (res.data.status === 200) {
          setEvents(res.data.event);
        }
      });
  }, []);

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="AS">
        <AllDataHeader title="Show Invitation" image={cup} count={"Zero"} />

        <AuditionCardReuse
          data={events}
          urlLink={`/audition-admin/audition/round-instruction-video-details`}
        />
      </div>
    </>
  );
};

export default RoundInstructionVideoList;
